var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"rounded focus:outline-none",class:[
    _vm.background ? _vm.background : 'bg-primary-yellow',
    _vm.width,
    _vm.height,
    _vm.opacity ? _vm.opacity : null,
    _vm.p ? _vm.p : 'py-2 px-6 md:py-2 md:px-8',
    _vm.color ? _vm.color : 'text-charcoal',
    _vm.border ? _vm.border : null,
    _vm.borderColor ? _vm.borderColor : null,
    _vm.font ? _vm.font : 'text-base',
  ],style:({ background: _vm.background, width : _vm.width, height: _vm.height }),attrs:{"disabled":_vm.disableButton,"type":_vm.type},on:{"click":_vm.onClick}},[(_vm.loading)?_c('div',{staticClass:"loader"}):_c('p',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }